import { useEffect, useState } from 'react';
import type {
  CompletionConfigurationOption,
  CompletionConfigurationResponse,
  CompletionPromptConfigurationOption,
} from 'types/api-responses';
import { getDefaultPrompt, getFormDefaults } from './utils';

// OCR / LLM / prompt selection for an upload surface whose config loads asynchronously
// (unlike the Add Document modal, which only mounts once config is present and seeds
// synchronously). Seeds the defaults when config arrives and re-seeds when the filtered
// prompt list changes.
export const useProvisionFieldSelection = (
  config: CompletionConfigurationResponse | undefined,
  filteredPrompts: CompletionPromptConfigurationOption[]
) => {
  const [ocrModel, setOcrModel] = useState<CompletionConfigurationOption>();
  const [llmModel, setLlmModel] = useState<CompletionConfigurationOption>();
  const [promptVersion, setPromptVersion] =
    useState<CompletionPromptConfigurationOption>();

  useEffect(() => {
    if (!config) return;
    const defaults = getFormDefaults(config);
    setOcrModel(defaults.extractionConfigurations);
    setLlmModel(defaults.completionConfigurations);
    setPromptVersion(getDefaultPrompt(filteredPrompts));
  }, [config, filteredPrompts]);

  return {
    ocrModel,
    setOcrModel,
    llmModel,
    setLlmModel,
    promptVersion,
    setPromptVersion,
  };
};
